<footer class="py-base bg-neutral-lighter border-t border-neutral-base text-base lg:text-sm
text-neutral-dark mt-lg">
  <div class="container mx-auto px-base ">
  <div class="overflow-hidden pb-8">
    <div class="flex flex-wrap w-full pt-2 items-baseline">
      <img src="assets/icons/ai.svg" alt="Aviso IA" class="h-[1em] w-auto mr-1" />
      <span>
        Este sistema usa inteligencia artificial. El contenido generado por IA puede ser incorrecto, revise los resultados.
      </span>
    </div>
  </div>
    <div class="flex flex-wrap flex-col lg:flex-row justify-between">
      <div class="mb-base">
        <h2 class="sr-only">Enlaces a pie de página</h2>
        <ul class="flex flex-col lg:flex-row lg:flex-wrap mb-base">
          <li class="mb-sm mr-base">
            <a class="c-link font-semibold font-semibold cursor-pointer" (click)="navigationService.goToAccesibilidad()">Accesibilidad</a>
          </li>
          <li class="mb-sm mr-base">
            <a class="c-link font-semibold font-semibold cursor-pointer" (click)="navigationService.goToMapaWeb()">Mapa web</a>
          </li>
        </ul>
        <div>
          <p>
            Todo el contenido bajo
            <a
              class="c-link c-link--neutral"
              href="https://creativecommons.org/licenses/by/4.0/legalcode.es"
              rel="license">licencia CC BY 4.0</a>
          </p>
        </div>
        <div>
          <p>
            <a
              class="c-link c-link--neutral"
              href="https://www.aragon.es/">Gobierno de Aragón</a>. Edificio Pignatelli. Paseo María Agustín, 36. 50004 - Zaragoza - Teléfono: <a href="tel:+34976714000" class="c-link c-link--neutral">976 714 000</a>
          </p>
        </div>
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="flex flex-wrap gap-base lg:gap-x-2xl w-full pt-lg">
        <div>
          <img 
        src="assets/icons/logo_footer.png" 
        alt="Servicios Digitales de Aragón (SDA)" 
        class="w-auto "
      />
        </div>
      </div>
    </div>
  </div>
</footer>
            